const scope = {
    name_exists: 'Tên scope {{name}} đã được sử dụng',
    name_with_space: 'Tên của scope không được chứa dấu cách.',
};
export default Object.freeze(scope);
